import React from 'react';
import { ServiceCardIcon } from './styles/modalStyles';

export const AdditionalServiceCardIcon = ({ icon, title }) => (
  <ServiceCardIcon>
    <img src={icon} alt={title} />
  </ServiceCardIcon>
);
